import moment from 'moment';
import APIUtils from '@spothero/utils/api';

const EventsAPI = {
    get({destinationId, eventTypes = null, starts = moment().format()}) {
        const data = {
            destination_id: destinationId, // eslint-disable-line camelcase
            page_size: 0, // eslint-disable-line camelcase
            starts,
            include: 'search_url',
        };

        if (eventTypes) {
            data.event_types = eventTypes; // eslint-disable-line camelcase
        }

        return APIUtils.get('events/', data);
    },

    getById(eventId) {
        return APIUtils.get(`events/${eventId}/`, {
            include:
                'search_url,meta_description,meta_title,short_description,description,custom_description',
        });
    },
};

export default EventsAPI;
